export type Option<A>
  = { kind: "some", value: A }
  | { kind: "none" }

export const makeOpt: <A>(x: A) => Option<A> =
  x => ({ kind: "some", value: x })

export const emptyOpt: <A>() => Option<A> =
  () => ({ kind: "none" })